import { useFormState } from "react-hook-form";

export const useFormButtonStateDisabled = (forceDisabled?: boolean) => {
  const { isSubmitting, disabled, isDirty, dirtyFields } = useFormState();
  if (typeof forceDisabled === "boolean") {
    return forceDisabled;
  }
  const isFormDirty = isDirty && Object.keys(dirtyFields).length > 0;
  const isDisabled = isSubmitting || disabled || !isFormDirty;
  return isDisabled;
};
